import type { DateTime } from "luxon";

/** A week's month label: "July 2026", or "June - July 2026" across a month end. */
export const formatDateRange = (
	startDate: DateTime | undefined,
	endDate: DateTime | undefined,
	locale: string,
	// Hospital demo → abbreviated month (Jul 2026); everyone else → full month (July 2026).
	isHospitalDemo: boolean,
) => {
	if (startDate && endDate) {
		const startMoment = startDate.setLocale(locale);
		const endMoment = endDate.setLocale(locale);
		const monthFormat = isHospitalDemo ? "MMM" : "MMMM";

		if (startMoment.month === endMoment.month) {
			// Same month
			return startMoment.toFormat(`${monthFormat} yyyy`);
		}
		// Different months
		return `${startMoment.toFormat(monthFormat)} - ${endMoment.toFormat(`${monthFormat} yyyy`)}`;
	}
	return "";
};
